export enum OrdenamientosRespuestasEnum { NOMBRE, CANTIDAD }
